import { useCallback, useRef, useState } from 'react';
import { getCaseMovements } from 'services/unholsterDailyStateService';

export default function useUnholsterCaseMovements() {
  const [data, setData] = useState([]);
  const [meta, setMeta] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const abortControllerRef = useRef(null);

  const fetchMovements = useCallback(async (caseId) => {
    if (!caseId) return;

    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsLoading(true);
    setError(null);

    try {
      const result = await getCaseMovements(caseId, controller.signal);

      setData(result?.items ?? []);
      setMeta(result?.meta ?? null);
    } catch (err) {
      if (err.name === 'AbortError' || err.name === 'CanceledError') return;

      setData([]);
      setMeta(null);
      setError(err);
    } finally {
      if (!controller.signal.aborted) setIsLoading(false);
    }
  }, []);

  // Parche local de una fila: la gestion pinta antes del await y revierte si falla.
  const patchRow = useCallback((estadoDiarioId, patch) => {
    setData((prev) =>
      prev.map((r) => (r.estadoDiarioId === estadoDiarioId ? { ...r, ...patch } : r))
    );
  }, []);

  return { data, meta, isLoading, error, fetchMovements, patchRow };
}
